export function slugTransform(name: string) {
  if (!name) {
    return ''
  }

  return name
    .toLowerCase()
    .trim()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '') // Remove acentos
    .replace(/[^a-z0-9\s-]/g, '') // Remove caracteres não alfanuméricos
    .replace(/\s+/g, '-') // Substitui espaços por hífens
    .replace(/-+/g, '-') // Substitui múltiplos hífens por um único
    .replace(/^-+/, '') // Remove hífen no início
    .replace(/-+$/, '') // Remove hífen no final
}
